export const kajikajyBrand = {
    colors: {
        green: "#DC2626",
        greenDark: "#EF4444",
        red: "#DC2626",
        redDark: "#EF4444",
        blue: "#1A6FE8",
        amber: "#D97706",
        indigo: "#6366F1",
        ink: "#0F1117",
        inkSoft: "#374151",
        muted: "#6B7280",
        canvas: "#FFFFFF",
        canvasAlt: "#F7F7F7",
        night: "#0A0A0F",
        nightAlt: "#13131A",
        border: "#E2E5EC",
        borderStrong: "#CDD1DB",
        greenTint: "#FEF2F2",
        greenBorder: "#FECACA",
        blueTint: "#DBEAFE",
        amberTint: "#FEF3C7",
        redTint: "#FEF2F2"
    },
    radius: {
        sm: "8px",
        md: "10px",
        lg: "12px"
    },
    fontFamily: "Rubik Variable, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif"
};
export const kajikajyCssVariables = `
  --k-green: ${kajikajyBrand.colors.green};
  --k-red: ${kajikajyBrand.colors.red};
  --k-blue: ${kajikajyBrand.colors.blue};
  --k-amber: ${kajikajyBrand.colors.amber};
  --k-indigo: ${kajikajyBrand.colors.indigo};
  --k-ink: ${kajikajyBrand.colors.ink};
  --k-muted: ${kajikajyBrand.colors.muted};
  --k-canvas: ${kajikajyBrand.colors.canvas};
  --k-canvas-alt: ${kajikajyBrand.colors.canvasAlt};
  --k-border: ${kajikajyBrand.colors.border};
`;
export const KAJIKAJY_THEME_STORAGE_KEY = "kajikajy-theme";
const themeCookieMaxAgeSeconds = 60 * 60 * 24 * 365;
function isKajikajyThemeMode(value) {
    return value === "light" || value === "dark";
}
export function readSharedKajikajyTheme() {
    if (typeof document === "undefined") {
        return null;
    }
    const prefix = `${KAJIKAJY_THEME_STORAGE_KEY}=`;
    const value = document.cookie
        .split(";")
        .map((entry) => entry.trim())
        .find((entry) => entry.startsWith(prefix))
        ?.slice(prefix.length) ?? null;
    return isKajikajyThemeMode(value) ? value : null;
}
export function getInitialKajikajyTheme() {
    if (typeof window === "undefined") {
        return "light";
    }
    const sharedTheme = readSharedKajikajyTheme();
    if (sharedTheme) {
        return sharedTheme;
    }
    try {
        const localTheme = window.localStorage.getItem(KAJIKAJY_THEME_STORAGE_KEY);
        if (isKajikajyThemeMode(localTheme)) {
            return localTheme;
        }
    }
    catch {
        // Continue with the operating-system preference when storage is unavailable.
    }
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
export function applyKajikajyTheme(theme) {
    if (typeof document === "undefined") {
        return;
    }
    document.documentElement.dataset.theme = theme;
    document.documentElement.style.colorScheme = theme;
}
export function persistKajikajyTheme(theme) {
    if (typeof window === "undefined" || typeof document === "undefined") {
        return;
    }
    try {
        window.localStorage.setItem(KAJIKAJY_THEME_STORAGE_KEY, theme);
    }
    catch {
        // The shared cookie remains the source of truth when storage is unavailable.
    }
    const hostname = window.location.hostname;
    const domain = hostname === "kajikajy.com" || hostname.endsWith(".kajikajy.com")
        ? "; Domain=.kajikajy.com"
        : "";
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie =
        `${KAJIKAJY_THEME_STORAGE_KEY}=${theme}; Path=/; Max-Age=${themeCookieMaxAgeSeconds}; SameSite=Lax` +
            `${domain}${secure}`;
}
//# sourceMappingURL=theme.js.map